import {
    SET_CHECKIN_STATUS,
    SET_CHECKIN_LOCATION,
    SET_CHECKIN_TIME
  } from "../Action/checkinAction";
  
  const initialState = {
    checkedIn: false,
    locationName: '',
    checkinTime: '', 
  };
  
  const checkinReducer = (state = initialState, action) => {
    switch (action.type) {
      case SET_CHECKIN_STATUS:
        return {
          ...state,
          checkedIn: action.payload,
        };
      case SET_CHECKIN_LOCATION:
        return {
          ...state,
          locationName: action.payload,
        };
      case SET_CHECKIN_TIME:
        return {
          ...state,
          checkinTime: action.payload,
        };
      default:
        return state;
    }
  };
  
  export default checkinReducer;
  